import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as strings from '../../../base/common/strings.js';
export var Viewport = function Viewport(top, left, width, height) {
  _classCallCheck(this, Viewport);

  this.top = top | 0;
  this.left = left | 0;
  this.width = width | 0;
  this.height = height | 0;
};
export var MinimapLinesRenderingData = function MinimapLinesRenderingData(tabSize, data) {
  _classCallCheck(this, MinimapLinesRenderingData);

  this.tabSize = tabSize;
  this.data = data;
};
export var ViewLineData = function ViewLineData(content, continuesWithWrappedLine, minColumn, maxColumn, startVisibleColumn, tokens) {
  _classCallCheck(this, ViewLineData);

  this.content = content;
  this.continuesWithWrappedLine = continuesWithWrappedLine;
  this.minColumn = minColumn;
  this.maxColumn = maxColumn;
  this.startVisibleColumn = startVisibleColumn;
  this.tokens = tokens;
};
export var ViewLineRenderingData = /*#__PURE__*/function () {
  function ViewLineRenderingData(minColumn, maxColumn, content, continuesWithWrappedLine, mightContainRTL, mightContainNonBasicASCII, tokens, inlineDecorations, tabSize, startVisibleColumn) {
    _classCallCheck(this, ViewLineRenderingData);

    this.minColumn = minColumn;
    this.maxColumn = maxColumn;
    this.content = content;
    this.continuesWithWrappedLine = continuesWithWrappedLine;
    this.isBasicASCII = ViewLineRenderingData.isBasicASCII(content, mightContainNonBasicASCII);
    this.containsRTL = ViewLineRenderingData.containsRTL(content, this.isBasicASCII, mightContainRTL);
    this.tokens = tokens;
    this.inlineDecorations = inlineDecorations;
    this.tabSize = tabSize;
    this.startVisibleColumn = startVisibleColumn;
  }

  _createClass(ViewLineRenderingData, null, [{
    key: "isBasicASCII",
    value: function isBasicASCII(lineContent, mightContainNonBasicASCII) {
      if (mightContainNonBasicASCII) {
        return strings.isBasicASCII(lineContent);
      }

      return true;
    }
  }, {
    key: "containsRTL",
    value: function containsRTL(lineContent, isBasicASCII, mightContainRTL) {
      if (!isBasicASCII && mightContainRTL) {
        return strings.containsRTL(lineContent);
      }

      return false;
    }
  }]);

  return ViewLineRenderingData;
}();
export var InlineDecoration = function InlineDecoration(range, inlineClassName, type) {
  _classCallCheck(this, InlineDecoration);

  this.range = range;
  this.inlineClassName = inlineClassName;
  this.type = type;
};
export var ViewModelDecoration = function ViewModelDecoration(range, options) {
  _classCallCheck(this, ViewModelDecoration);

  this.range = range;
  this.options = options;
};